export default {
  MuiButtonGroup: {
    styleOverrides: {
      root: {
        borderRadius: 6
      }
    }
  }
}
